import { memo } from "react";

import "./BaseTooltip.scss";

const positions = {
  top: "top",
  left: "left",
  right: "right",
  bottom: "bottom"
};
/**
 * @deprecated should be using <Tooltip /> from base component folder instead of this component
 * @param text, position, children, style, className
 * @returns  BaseTooltip component
 */
function BaseTooltip({
  text = "",
  position = positions.bottom,
  children,
  style = null,
  className = ""
}) {
  return (
    <div className={`BaseTooltip ${position} ${className}`} data-tip={text} style={style}>
      {children}
    </div>
  );
}
export default memo(BaseTooltip);
